function adjustVideoPadding() {
  const containers = document.querySelectorAll(".embed-container");

  containers.forEach((container) => {
    const video = container.querySelector("video");
    const iframe = container.querySelector("iframe");

    // Handle HTML5 video elements
    if (video) {
      const sourceElement = video.querySelector("source");
      if (!sourceElement) {
        return;
      }

      const source = sourceElement.src;

      // Create a temporary video element to fetch dimensions
      const tempVideo = document.createElement("video");
      tempVideo.src = source;

      // Wait for metadata to load to get dimensions
      tempVideo.addEventListener("loadedmetadata", () => {
        const width = tempVideo.videoWidth;
        const height = tempVideo.videoHeight;
        const aspectRatio = (height / width) * 100;

        // Apply calculated padding to the container
        container.style.paddingBottom = `${aspectRatio}%`;

        // Set up poster frame capture
        video.currentTime = 0.5;

        // When the video can play, capture the frame
        video.addEventListener(
          "canplay",
          () => {
            // Create a canvas to capture the frame
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");

            // Draw the current frame
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Set the poster to the captured frame
            video.poster = canvas.toDataURL();

            // Reset the video time to 0
            video.currentTime = 0;
          },
          { once: true }
        );
      });
    }

    // Handle iframe elements (like Vimeo, YouTube, etc.)
    if (iframe) {
      // For iframes, we can't easily get the aspect ratio from the source
      // So we'll use a default 16:9 ratio (56.25%) or try to extract from width/height attributes
      let aspectRatio = 56.25; // Default 16:9 ratio

      const width = iframe.getAttribute("width");
      const height = iframe.getAttribute("height");

      if (width && height) {
        const widthNum = parseInt(width);
        const heightNum = parseInt(height);
        if (widthNum && heightNum) {
          aspectRatio = (heightNum / widthNum) * 100;
        }
      }

      // Apply calculated padding to the container
      container.style.paddingBottom = `${aspectRatio}%`;
    }
  });
}

// Call the function when the page loads
window.onload = adjustVideoPadding;
